/** URL-Path to the 3D-scene */
export const QUERY_PARAM__SCENE = 'scene';
/** URL-path to the background */
export const QUERY_PARAM__BACKGROUND = 'background';
/** URL-path to the environment-map */
export const QUERY_PARAM__ENVIRONMENT_MAP = 'environmentMap';
/** Disable lights in the scene (boolean) */
export const QUERY_PARAM__DISABLE_LIGHTS = 'disableLights';
/** Use the environment-map as background (boolean) */
export const QUERY_PARAM__USE_ENV_MAP_AS_BACKGROUND = 'useEnvMapAsBackground';
/** Name of the camera-object in the loaded scene */
export const NAME__CAMERA_TARGET = 'camera_target';
/** Name of the object in the scene, the camera points to */
export const NAME__CAMERA_NAME = 'scene_camera';
/** Name of the illuminant-light of the luminaire */
export const NAME__ILLUMINANT = 'illuminant';
/** Name of the top-light in the scene */
export const NAME__TOP_LIGHT = 'scene_light_top';
/** Name of the bottom-light in the scene */
export const NAME_BOTTOM_LIGHT = 'scene_light_bottom';
